import { useState } from 'react'
import type { Section, Slide, SlideInput } from '../../types'
import { EMPTY_SLIDE } from './constants'
import { useI18n } from '../../i18n'
import { useSlidesAuthGuard } from './slides-manager/useSlidesAuthGuard'
import { useSlidesCrudActions } from './slides-manager/useSlidesCrudActions'
import { useSlidesDragAndDrop } from './slides-manager/useSlidesDragAndDrop'

type Args = {
  token: string | null
  authHeaders: (withJson?: boolean) => Record<string, string>
  setSection: (section: Section) => void
}

const useSlidesManager = ({ token, authHeaders, setSection }: Args) => {
  const [slides, setSlides] = useState<Slide[]>([])
  const [slideForm, setSlideForm] = useState<SlideInput>(EMPTY_SLIDE)
  const [editingId, setEditingId] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)
  const { t } = useI18n()

  const requireAuth = useSlidesAuthGuard({ token, t })

  const { loadSlides, resetSlideForm, selectForEdit, upsertSlide, deleteSlide, persistOrder } =
    useSlidesCrudActions({
      authHeaders,
      editingId,
      slideForm,
      setSlides,
      setLoading,
      setSlideForm,
      setEditingId,
      setSection,
      t,
      requireAuth,
    })

  const { onDropSlide, onDragStart } = useSlidesDragAndDrop({
    slides,
    setSlides,
    persistOrder,
  })

  return {
    slides,
    loading,
    slideForm,
    setSlideForm,
    editingId,
    loadSlides,
    upsertSlide,
    resetSlideForm,
    deleteSlide,
    selectForEdit,
    onDropSlide,
    onDragStart,
  }
}

export default useSlidesManager
